import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import {
    Box,
    Typography,
    Select,
    MenuItem,
} from "@mui/material"
import UploadComponent from "src/v2/components/upload/upload-component"
import theme from "src/v2/theme/theme"
import GridRadioButton from "src/v2/components/radio-button/grid-radio-button"

const removeExtensaoArquivo = (fileName = "") => {
    return fileName.replace(/\.[^/.]+$/, "")
}

const CadastroLoteUpload = ({
    modelFile,
    setModelFile,
    projetar,
    setProjetar,
    modelosArquivo,
    modeloProjetar,
    onSend,
}) => {
    const fileInputRef = useRef(null)
    const [uploadKey, setUploadKey] = useState(0)

    const habilitaProjetar = modelFile === modeloProjetar

    const menuItemSx = {
        color: theme.palette.primary.contrastText,

        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
        },

        "&.Mui-selected": {
            backgroundColor: theme.palette.primary.dark,
        },

        "&.Mui-selected:hover": {
            backgroundColor: theme.palette.primary.dark,
        },
    }

    const handleFileSelect = (file) => {
        if (!file) {
            setModelFile("")
            return
        }

        const modeloArquivo = removeExtensaoArquivo(file.name)

        if (modelosArquivo.includes(modeloArquivo)) {
            setModelFile(modeloArquivo)
        }
    }

    const handleEnviar = async (file) => {
        if (!file) return

        const sucesso = await onSend?.({
            arquivo: file,
            model: modelFile,
            projetar_eventos: projetar,
        })

        if (sucesso) {
            if (fileInputRef.current) {
                fileInputRef.current.value = ""
            }

            setModelFile("")
            setProjetar(false)
            setUploadKey((prev) => prev + 1)
        }
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
            }}
        >
            <Box>
                <Typography
                    sx={{
                        color: theme.palette.primary.contrastText,
                        mb: 1,
                    }}
                >
                    MODELO DO ARQUIVO
                </Typography>

                <Select
                    value={modelFile}
                    onChange={(event) => setModelFile(event.target.value)}
                    displayEmpty
                    fullWidth
                    variant="standard"
                    renderValue={(selected) => {
                        if (!selected) {
                            return "Selecione o modelo"
                        }
                        return selected
                    }}
                    sx={{
                        width: "100%",
                        color: theme.palette.primary.contrastText,
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        pb: 0.5,

                        "&:before": {
                            borderBottom: "none",
                        },
                        "&:after": {
                            borderBottom: "none",
                        },
                        "&:hover:not(.Mui-disabled):before": {
                            borderBottom: "none",
                        },
                        "& .MuiSvgIcon-root": {
                            color: theme.palette.primary.contrastText,
                        },
                    }}
                >
                    {modelosArquivo.map((modelo) => (
                        <MenuItem
                            key={modelo}
                            value={modelo}
                            sx={menuItemSx}
                        >
                            {modelo}
                        </MenuItem>
                    ))}
                </Select>
            </Box>

            {habilitaProjetar && (
                <Box
                    sx={{
                        width: "180px",
                    }}
                >
                    <GridRadioButton
                        title="PROJETAR"
                        value={projetar ? "sim" : "nao"}
                        defaultRadioValue="nao"
                        onChange={(event) => {
                            setProjetar(event.target.value === "sim")
                        }}
                        radioButtonItems={[
                            { value: "sim", label: "SIM" },
                            { value: "nao", label: "NÃO" },
                        ]}
                        columns={2}
                        direction="row"
                        itemsPerColumn={1}
                        spacing={{ mt: 0, mb: 0 }}
                        horizontalSpacing={0.5}
                    />
                </Box>
            )}

            <Box
                sx={{
                    width: "75%",
                    minWidth: "700px",
                    maxWidth: "1000px",
                    alignSelf: "center",
                    mb: 2,
                    mt: 2,
                }}
            >
                <UploadComponent
                    key={uploadKey}
                    compact
                    accept=".xlsx,.csv,.json"
                    fileInputRef={fileInputRef}
                    onFileSelect={handleFileSelect}
                    onSendFile={handleEnviar}
                />
            </Box>
        </Box>
    )
}

CadastroLoteUpload.propTypes = {
    modelFile: PropTypes.string.isRequired,
    setModelFile: PropTypes.func.isRequired,
    projetar: PropTypes.bool.isRequired,
    setProjetar: PropTypes.func.isRequired,
    modelosArquivo: PropTypes.arrayOf(PropTypes.string).isRequired,
    modeloProjetar: PropTypes.string.isRequired,
    onSend: PropTypes.func,
}

export default CadastroLoteUpload